import type { IAddonProductConstructorParams } from "@services/sdk/interfaces";
import type { ID } from "@services/sdk/types";
import { map } from "ramda";

import Product from "./product";
import ProductInfo from "./product-info";

class AddonProduct extends Product {
	public static ConstructList(
		arrParams: Array<IAddonProductConstructorParams>,
	): Array<AddonProduct> {
		return map(AddonProduct.Construct)(arrParams);
	}

	public static Construct(
		params: IAddonProductConstructorParams,
	): AddonProduct {
		return new AddonProduct(params);
	}

	responseData: IAddonProductConstructorParams;

	constructor(params: IAddonProductConstructorParams) {
		super(params);
		this.responseData = params;
	}

	get id(): ID {
		if (this.responseData?.id) {
			return this.responseData.id;
		}
		return null;
	}

	get name(): string {
		return this.responseData.name;
	}

	get iconRef(): string {
		if (!this.responseData.appUserData.iconRef) {
			return "felix";
		}

		return this.responseData.appUserData.iconRef;
	}

	get hasInfo(): boolean {
		return !!this.info;
	}

	get info(): ProductInfo | null {
		if (!this.responseData.appUserData.info) {
			return null;
		}

		return ProductInfo.Construct(this.responseData.appUserData.info);
	}

	get extraInclusions(): Array<string> {
		const res = this.responseData.appUserData.extraInclusions;

		if (!res) {
			return [];
		}

		return res;
	}
}

export default AddonProduct;
